import styled, { css } from 'styled-components';
import { tokens } from '../../../design/tokens';

export const Container = styled.div<{ full: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;

  ${({ full }) =>
    full &&
    css`
      grid-column: 1 / -1;
    `}
`;

export const Label = styled.label`
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.label.size};
  font-weight: ${tokens.font.label.weight};

  span {
    color: ${tokens.color.errorRed};
  }
`;

export const Control = styled.div<{ invalid: boolean }>`
  display: flex;
  flex-direction: column;

  /* Apenas o controle DIRETO do campo. Sem o ">", o seletor pegava também os
     inputs aninhados (radio e alternativas do OptionsEditor) e os esticava
     para 100%, desalinhando o editor de alternativas. */
  > input,
  > textarea {
    width: 100%;
    min-height: 44px; /* mesma altura do Dropdown e alvo de toque confortável */
    padding: 10px 12px;
    background: ${tokens.color.fieldSlate};
    border: 1px solid transparent;
    border-radius: ${tokens.radius.sm};
    color: ${tokens.color.textWhite};
    font-size: ${tokens.font.body.size};
    font-family: inherit;

    &::placeholder {
      color: ${tokens.color.textAsh};
    }

    &:focus {
      outline: none;
      border-color: ${tokens.color.focusAmber};
    }

    &:focus-visible {
      outline: 2px solid ${tokens.color.focusAmber};
      outline-offset: 1px;
    }
  }

  > textarea {
    min-height: 88px;
    resize: vertical;
  }

  ${({ invalid }) =>
    invalid &&
    css`
      > input,
      > textarea {
        border-color: ${tokens.color.errorRed};
      }
    `}
`;

/* Campo com prefixo/sufixo: a caixa é o wrapper; o input dentro dele é
   transparente, e o foco acende a caixa inteira. */
export const Affixed = styled.div<{ invalid: boolean }>`
  display: flex;
  align-items: center;
  min-height: 44px;
  background: ${tokens.color.fieldSlate};
  border: 1px solid ${({ invalid }) => (invalid ? tokens.color.errorRed : 'transparent')};
  border-radius: ${tokens.radius.sm};

  &:focus-within {
    border-color: ${tokens.color.focusAmber};
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 1px;
  }

  > input {
    flex: 1;
    min-width: 0;
    padding: 10px 12px;
    background: transparent;
    border: 0;
    color: ${tokens.color.textWhite};
    font-size: ${tokens.font.body.size};
    font-family: inherit;

    &::placeholder {
      color: ${tokens.color.textAsh};
    }

    &:focus,
    &:focus-visible {
      outline: none;
    }
  }
`;

export const Affix = styled.span`
  padding: 0 12px;
  color: ${tokens.color.textMist};
  font-size: ${tokens.font.body.size};
  font-variant-numeric: tabular-nums;
  white-space: nowrap;

  &:first-child {
    padding-right: 0;
  }

  &:last-child {
    padding-left: 0;
  }
`;

export const Hint = styled.span<{ invalid: boolean }>`
  color: ${({ invalid }) => (invalid ? tokens.color.errorRed : tokens.color.textAsh)};
  font-size: ${tokens.font.caption.size};
`;

export const TextInput = styled.input.attrs({ type: 'text' })``;

export const TextArea = styled.textarea``;
